import { t, ui } from '../i18n';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  Divider
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  AccountTree as BlocksIcon,
  SwapHoriz as TransactionIcon,
  Person as PersonIcon
} from '@mui/icons-material';

interface KAISTSidebarProps {
  open: boolean;
  onClose: () => void;
}

const drawerWidth = 280;

const KAISTSidebar: React.FC<KAISTSidebarProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      text: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard',
      color: '#1976d2'
    },
    {
      text: 'My Transactions',
      icon: <TransactionIcon />,
      path: '/transactions',
      color: '#7c4dff'
    },
    {
      text: 'My Blocks',
      icon: <BlocksIcon />,
      path: '/blocks',
      color: '#4caf50'
    },
    {
      text: 'My Info',
      icon: <PersonIcon />,
      path: '/my-info',
      color: '#ff9800'
    }
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const isSelected = (path: string) => {
    return location.pathname === path || 
           (path === '/dashboard' && location.pathname === '/');
  };
  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={open}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: 'white',
          borderRight: '1px solid #e0e0e0',
          paddingTop: '70px'
        },
      }}
    >
      <Box sx={{ overflow: 'auto' }}>
        {/* Organization Info */}
        <Box sx={{ p: 2, backgroundColor: '#1976d2', color: 'white' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0.5 }}>{t("KAIST Organization")}</Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, fontSize: '0.85rem', lineHeight: 1.3 }}>{t("KAIST - AI Optimization & Container Routing Decision Engine")}</Typography>
        </Box>

        <Divider />

        {/* Navigation Menu */}
        <List sx={{ pt: 2 }}>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding sx={{ mb: 1, px: 1 }}>
              <ListItemButton
                onClick={() => handleNavigation(item.path)}
                selected={isSelected(item.path)}
                sx={{
                  borderRadius: 2,
                  mx: 1,
                  '&.Mui-selected': {
                    backgroundColor: `${item.color}15`,
                    color: item.color,
                    '& .MuiListItemIcon-root': {
                      color: item.color,
                    },
                    '&:hover': {
                      backgroundColor: `${item.color}25`,
                    }
                  },
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isSelected(item.path) ? item.color : 'inherit',
                    minWidth: 40
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={ui(item.text)}
                  sx={{
                    '& .MuiTypography-root': {
                      fontWeight: isSelected(item.path) ? 'bold' : 'normal',
                      color: isSelected(item.path) ? item.color : 'inherit'
                    }
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default KAISTSidebar;
